import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, SagaRunRequest, SagaResult } from '../types/showcase';

/** C067 Saga 데모(격리) — POST .../saga/run (queue #646 §R646-2). */
export function useSagaRun() {
  return useMutation<SagaResult, ApiError, SagaRunRequest>({
    mutationFn: (req) => showcaseApi.sagaRun(req),
    mutationKey: ['common-showcase', 'saga', 'run'],
  });
}
